"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZAxis = void 0;
/**
 * @fileOverview Z Axis
 */

var ZAxis = exports.ZAxis = function ZAxis() {
  return null;
};
ZAxis.displayName = 'ZAxis';
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
};